module.exports = __webpack_public_path__ + "img/Vivian_O_1.204075de.jpg";